/* eslint-disable no-undef,no-restricted-syntax */
import React, { Component } from 'react';
import styled from 'styled-components';
import MarkerClustering from './MarkerClustering';
// import { Button } from 'semantic-ui-react';
import pinIcon from 'images/mapClustoer/icon_pin.png';
// import companyIcon from 'images/mapClustoer/companyIcon.svg';
// import sIcon from 'images/mapClustoer/sIcon.svg';marker_favorite
import companyIcon from 'images/mapClustoer/companyIcon.svg';
import marker_favorite from 'images/mapClustoer/marker_favorite.png';
import clusterMarker1 from 'images/mapClustoer/cluster-marker-1.png';
import clusterMarker2 from 'images/mapClustoer/cluster-marker-2.png';
import clusterMarker3 from 'images/mapClustoer/cluster-marker-3.png';
import clusterMarker4 from 'images/mapClustoer/cluster-marker-4.png';
import clusterMarker5 from 'images/mapClustoer/cluster-marker-5.png';
import ic24 from 'images/mapClustoer/ic24.svg';
import ellipse from 'images/mapClustoer/ellipse.png';

const { naver } = window;

// 클러스터 아이콘은 naver 전역(N)에 의존 → 모듈 로드 시점 말고 호출 시점에 생성
const buildClusterIcons = () => {
  const icon = () => ({
    content: `<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(${ellipse});background-size:contain;"></div>`,
    size: N.Size(40, 40),
    anchor: N.Point(20, 20)
  });
  return [icon(), icon(), icon(), icon(), icon()];
};

const MapWrapper = styled.div`
  height: 100%;
  width: 70%;
  display: flex;
  align-items: center;
  position: relative;

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: calc((100vh - 126px) / 2);
    margin-left: 0;
    height: 180px;
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const Button = styled.button`
  position: absolute;
  z-index: 1;
  width: 56px;
  height: 56px;
  margin-left: 12px;
  background: #fff;
  border: 0.5px solid #afb2b9;
  border-radius: 4px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  bottom: 20px;
  cursor: pointer;

  @media only screen and (max-width: 768px) {
    width: 40px;
    height: 40px;

    & img {
      width: 24px;
      height: 24px;
    }
  }
`;

// naver SDK 미로드 시 지도 영역 대체 표시
const MapFallback = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f5f6f7;
  color: #6b6e76;
  font-size: 14px;
  line-height: 1.6;
`;

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      pointMarker: null,
      markers: [],
      markerClustering: null,
      mapUnavailable: false
    };
  }

  componentDidMount() {
    // naver SDK 미로드(점검/503) 시 지도만 대체 표시, 나머지 화면은 정상 동작
    if (!naver || !naver.maps) {
      this.setState({ mapUnavailable: true });
      return;
    }
    this.landingMap();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!naver || !naver.maps) return;
    const { map: prevStores = {} } = prevProps || {};
    const { map: currStores = {} } = this.props;
    const { idx: prevIdx } = prevStores;
    const { idx, office: { gpsLat, gpsLon } = {}, stores } = currStores;
    if (prevIdx !== idx) {
      this.setMarkerPoint(gpsLat, gpsLon);
      this.setMarkerClusters(stores);
    }
  }

  landingMap = () => {
    const mapDiv = document.getElementById('map');
    if (!naver || !naver.maps) {
      return;
    }
    const mapData = new naver.maps.Map(mapDiv, {
      useStyleMap: true,
      center: new naver.maps.LatLng(37.5149888, 127.0614121),
      logoControl: false,
      zoom: 16, // 지도의 초기 줌 레벨
      minZoom: 14, // 지도의 최소 줌 레벨
      maxZoom: 20, // 지도의 최대 줌 레벨
      zoomControl: true, // 줌 컨트롤의 표시 여부
      zoomControlOptions: {
        position: naver.maps.Position.TOP_RIGHT
      }
    });
    this.setState({ map: mapData }, () => {
      // 보이는 부분만 마커 표시
      naver.maps.Event.addListener(mapData, 'idle', this.idleEvent);
    });
  };

  idleEvent = () => {
    const { map, markers } = this.state;
    this.updateMarkers(map, markers);
  };

  setMarkerPoint = (lat, lng) => {
    const position = new naver.maps.LatLng(lat, lng);
    const { map, pointMarker } = this.state;
    const markerOptions = {
      position,
      map,
      draggable: true,
      // icon,
      info: {
        name: '회사',
        sid: -1,
        intro: null
      }
    };
    if (pointMarker) pointMarker.setMap();
    const marker = new naver.maps.Marker(markerOptions);

    map.setCenter(position);
    this.setState({ center: position });

    // marker.setIcon({
    //   content: `<img src="${pinIcon}"
    // 		style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block; max-width: none; max-height: none; -webkit-user-select: none; position: absolute; width: 50px; height: 50px; left: 0px; top: 0px; z-index:1001">`,
    //   size: new naver.maps.Size(50, 50),
    //   anchor: new naver.maps.Point(25, 50)
    // });
    marker.setIcon({
      content: `<img src="${companyIcon}"
				style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block; max-width: none; max-height: none; -webkit-user-select: none; position: absolute; width: 50px; height: 50px; left: 0px; top: 0px; z-index:1001">`,
      size: new naver.maps.Size(50, 50),
      anchor: new naver.maps.Point(25, 50)
    });
    this.setState({ pointMarker: marker });
  };

  setMarkerClusters = (clusterList) => {
    if (!Array.isArray(clusterList)) {
      return;
    }
    const { setMarker } = this.props;
    const { map, markerClustering } = this.state;
    const markers = [];
    for (const spot of clusterList) {
      const { gpsLat, gpsLon, name } = spot;
      const position = new naver.maps.LatLng(gpsLat, gpsLon);
      const marker = new naver.maps.Marker({
        position,
        draggable: false
      });
      const infoWindow = new naver.maps.InfoWindow({
        content: `<div style="text-align:center;padding:10px;">${name}</div>`,
        anchorSize: new naver.maps.Size(15, 9),
        borderColor: '#EBEBEC',
        borderWidth: 1,
        borderRadius: 8
      });

      infoWindow.radius = 0;
      marker.setIcon({
        content: `<img src="${marker_favorite}" style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block; max-width: none; max-height: none; -webkit-user-select: none; position: absolute; width: 32px; height: 32px; left: 0px; top: 0px; z-index:1001">`,
        size: new naver.maps.Size(32, 32)
      });
      naver.maps.Event.addListener(marker, 'click', () => {
        if (infoWindow.getMap()) {
          infoWindow.close();
        } else {
          infoWindow.open(map, marker);
        }
      });
      markers.push(marker);
    }

    if (markerClustering) markerClustering.setMap();

    const newMarkerClustering = new MarkerClustering({
      minClusterSize: 3,
      maxZoom: 20,
      map,
      markers,
      disableClickZoom: false,
      gridSize: 120,
      icons: buildClusterIcons(),
      indexGenerator: [10, 20, 50, 100, 200],
      stylingFunction(clusterMarker, count) {
        $(clusterMarker.getElement())
          .find('div:first-child')
          .text(count);
      }
    });

    setMarker(markers);
    this.setState({ markers, markerClustering: newMarkerClustering });
  };

  updateMarkers = (map, markers) => {
    const mapBounds = map.getBounds();

    for (const marker of markers) {
      const position = marker.getPosition();

      if (mapBounds.hasLatLng(position)) {
        this.showMarker(map, marker);
      } else {
        this.hideMarker(map, marker);
      }
    }
  };

  showMarker = (map, marker) => {
    if (marker.setMap()) return;
    marker.setMap(map);
  };

  hideMarker = (map, marker) => {
    if (!marker.setMap()) return;
    marker.setMap(null);
  };

  getClickHandler = (infoWindow, marker) => {
    const { map } = this.state;
    return function handler() {
      if (infoWindow.getMap()) {
        infoWindow.close();
      } else {
        infoWindow.open(map, marker);
      }
    };
  };

  onClick = () => {
    const { map: currStores = {} } = this.props;
    const { office: { gpsLat, gpsLon } = {} } = currStores;
    const position = new naver.maps.LatLng(gpsLat, gpsLon);
    this.state.map.setCenter(position);
  };

  render() {
    const { mapUnavailable } = this.state;
    return (
      <MapWrapper>
        {!mapUnavailable && (
          <Button onClick={this.onClick}>
            <img src={ic24} />
          </Button>
        )}
        <MapContainer id="map" />
        {mapUnavailable && (
          <MapFallback>
            지도를 불러올 수 없습니다.
            <br />
            잠시 후 다시 시도해 주세요.
          </MapFallback>
        )}
      </MapWrapper>
    );
  }
}

export default React.memo(Map);
